<template>
  <div>
    <a-space>
      <vxe-input v-model="query['order.no']" placeholder="placeholder.receiptOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['command.id']" placeholder="business.label.commandId" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['storageRoom.name']" placeholder="business.label.storageRoom" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['zone.name']" placeholder="business.label.zone" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-date-range-picker v-model="query.range" linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
    </a-space>
    <a-space>
      <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['item.mnemonicCode']" placeholder="business.label.mnemonicCode" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['lot.no']" placeholder="business.label.lot" @clear="refresh" @keydown.native.enter="refresh"/>
    </a-space>
    <shelf-task ref="shelfTask"/>
  </div>
</template>

<script>
import moment from 'moment'
import { findAll } from '@/api/Api'
import ShelfTask from '@/views/inbound/shelf/ShelfTask.vue'
import { getOptions } from '@/utils/util'

export default {
  components: { ShelfTask },
    data() {
      return {
        loading: false,
        data: [],
        owners: [],
        page: 1,
        size: 5,
        contentSize: 0,
        selectedRowKeys: [],
        selectedRows: [],
        query: {
          'order.no': '',
          'command.id': '',
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'lot.no': '',
          'storageRoom.name': '',
          'zone.name': '',
          range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        }
      }
    },
  created() {
      findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
        if (res.success) {
          this.owners = getOptions(res.result)
        }
      })
    },
    methods: {
      refresh() {
        this.$refs.shelfTask.refresh(this.query)
      },
      reset() {
        this.query = {
          'order.no': '',
          'command.id': '',
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'lot.no': '',
          'storageRoom.name': '',
          'zone.name': '',
          range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        }
        this.$refs.shelfTask.reset()
      },
      confirm() {
        this.$refs.shelfTask.putaway()
      }
    }
  }
</script>